angular.module('aq.filters.transformers')
.filter('nonEmpty', function() {
    return function(input, field) {
        return _.filter(input, function(elem) {
           var value = elem[field];
           return value; 
        });
    }
});